import Repository from "@/repositories/api.js"
const resource = "/events"

export default {
  async getAll(mode = null) {
    let response = await Repository.get(resource, {
      params: { mode: mode }
    })
    return response.data.events
  },
  async get(eventID) {
    let response = await Repository.get(`${resource}/${eventID}`)
    return response.data.event
  },
  async create(eventData) {
    const { pretix_event_slug, connect_to_pretix, ...event } = eventData
    let response = await Repository.post(`${resource}`, {
      event: event,
      pretix_event_slug: connect_to_pretix ? pretix_event_slug : null,
      connect_to_pretix: connect_to_pretix
    })
    return response.data
  },
  async update(eventID, eventData) {
    const { pretix_event_slug, connect_to_pretix, ...event } = eventData
    let response = await Repository.patch(`${resource}/${eventID}`, {
      event: event,
      pretix_event_slug: connect_to_pretix ? pretix_event_slug : null,
      connect_to_pretix: connect_to_pretix
    })
    return response.data
  },
  async destroy(eventID) {
    let response = await Repository.delete(`${resource}/${eventID}`)
    return response.data
  },
  async disconnectPretix(eventID) {
    let response = await Repository.patch(
      `${resource}/${eventID}/disconnect_pretix`
    )
    return response.data
  }
}
